module.exports = __webpack_public_path__ + "static/media/bg.6da4d1fe.svg";